import { dateUStoISO } from './date-converter';

let cloneDeep = require('lodash.clonedeep');

function fromLocaleString(str) {
	const num = Number(str.replace(/[\s,$]/g,''));
	return num === num ? num : null;
}

export default (query = {}, page = 'properties') => {
	const where = [];
	const param = {};
	const order = [];

    // NOTE: the order of these properties must match the order in the PROPERTIES query (/src/data/queries.sql)
    const propertyFilter = [
        id => match(id, 'NAME'),
        id => match(id, 'CITY'),
        id => match(id, 'ADDRESS'),
        id => match(id, 'ZIP'),
        id => exact(id, 'STATE'),
        id => exact(id, 'TYPE'),
        id => exact(id, 'CATEGORY'),
        id => exact(id, 'SOURCE'),
        id => exact(id, 'TRANSACTION_TYPE'),
        id => multi(id, 'MARKET', 9),
        id => exact(id, 'SINGLE_TENANT_SUBCATEGORY'),
        id => exact(id, 'LEASE_TYPE'),
        id => exact(id, 'MULTI_TENANT_SUBCATEGORY'),
        id => exact(id, 'LISTING_AGENT_4'),
        id => exact(id, 'LISTING_AGENT_4_FIRM'),
        id => exact(id, 'BUYER_AGENT_4'),
        id => exact(id, 'BUYER_AGENT_4_FIRM'),
        id => num(id, 'SQFT_MIN'),
        id => num(id, 'SQFT_MAX'),
        id => num(id, 'LIST_PRICE_MIN'),
        id => num(id, 'LIST_PRICE_MAX'),
        id => num(id, 'NET_OPERATING_INCOME_MIN'),
        id => num(id, 'NET_OPERATING_INCOME_MAX'),
        id => num(id, 'SOLD_PRICE_MIN'),
        id => num(id, 'SOLD_PRICE_MAX'),
        id => num(id, 'CAPITALIZATION_RATE_MIN'),
        id => num(id, 'CAPITALIZATION_RATE_MAX'),
        id => num(id, 'PRICE_PER_SQFT_MIN'),
        id => num(id, 'PRICE_PER_SQFT_MAX'),
        id => num(id, 'CLOSE_PRICE_PER_SQFT_MIN'),
        id => num(id, 'CLOSE_PRICE_PER_SQFT_MAX'),
        id => remaingTime(id, 'LEASE_EXPIRATION_DATE_MIN'),
        id => remaingTime(id, 'LEASE_EXPIRATION_DATE_MAX'),
        id => exact(id, 'BUYER_COMPANY_STATE'),
        id => exact(id, 'SELLER_COMPANY_STATE'),
        id => multi(id, 'STATUS', 8),
        id => multi(id, 'HSC_STATUS', 4),
        id => exact(id, 'LISTING_AGENT_TEAM'),
        id => date(id, 'CLOSE_OF_ESCROW_MIN'),
        id => date(id, 'CLOSE_OF_ESCROW_MAX'),
        id => num(id, 'CLOSE_CAP_RATE_MIN'),
        id => num(id, 'CLOSE_CAP_RATE_MAX'),
        id => date(id, 'LISTED_DATE_MIN'),
        id => date(id, 'LISTED_DATE_MAX'),
        id => num(id, 'OCCUPANCY_MIN'),
        id => num(id, 'OCCUPANCY_MAX'),
        id => num(id, 'YEAR_BUILT_MIN'),
        id => num(id, 'YEAR_BUILT_MAX'),
        id => date(id, 'DATE_CREATED_MIN'),
        id => date(id, 'DATE_CREATED_MAX'),
        id => exact(id, 'CREATED_BY'),
        id => exact(id, 'STRIVE_SLIDER'),
        id => exact(id, 'FEATURED'),
        id => exact(id, 'VISIBLE'),
    ];

    // NOTE: the order of these properties must match the order in the PROPERTIES_BY_BUYER_STATE query
    // (/src/data/queries.sql)
    const buyerBreakdownFilter = cloneDeep(propertyFilter);
    buyerBreakdownFilter.push(
    	id => date(id, 'BASE_MIN'),
        id => date(id, 'BASE_MAX'),
        id => date(id, 'COMPARISON_MIN'),
        id => date(id, 'COMPARISON_MAX'),
	);

    // NOTE: the order of these properties must match the order in the TEXAS_TOTAL_TRANSACTIONS,
    // TEXAS_REGION_TRANSACTIONS, BUYERS_LOCATION_TOTAL, BUYERS_LOCATION queries (/src/data/queries.sql)
    const transactionBreakdownFilter = [
        id => exact(id, 'STATE'),
        id => exact(id, 'TYPE'),
        id => exact(id, 'CATEGORY'),
        id => exact(id, 'STATUS'),
        id => num(id, 'TRANSACTION_YEAR'),
        id => num(id, 'SOLD_PRICE_MIN'),
        id => num(id, 'SOLD_PRICE_MAX'),
        id => num(id, 'SQFT_MIN'),
        id => num(id, 'SQFT_MAX'),
    ];

    // NOTE: the order of these properties must match the order in the TEXAS_MARKET_TRANSACTIONS query
    // (/src/data/queries.sql)
    const marketTransactionBreakdownFilter = [
        id => exact(id, 'STATE'),
        id => exact(id, 'TYPE'),
        id => exact(id, 'CATEGORY'),
        id => exact(id, 'MARKET'),
        id => exact(id, 'STATUS'),
        id => num(id, 'TRANSACTION_YEAR'),
    ];

    // NOTE: the order of these properties must match the order in the AGENTS_LIST query (/src/data/queries.sql)
    const agentFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),
        id => exact(id, 'FIRM'),
    ];

    // NOTE: the order of these properties must match the order in the SELLERS_LIST query
    // (/src/data/queries.sql)
    const sellerFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),
        id => exact(id, 'PROFILE'),
        id => match(id, 'NOTES'),
        id => match(id, 'COMPANY_NAME'),
        id => match(id, 'COMPANY_ADDRESS'),
        id => match(id, 'COMPANY_CITY'),
        id => exact(id, 'COMPANY_STATE'),
        id => match(id, 'COMPANY_ZIP'),
    ];

    // NOTE: the order of these properties must match the order in the BUYERS_LIST query
    // (/src/data/queries.sql)
    const buyerFilter = [
        id => match(id, 'FIRST_NAME'),
        id => match(id, 'LAST_NAME'),
        id => match(id, 'EMAIL'),
        id => match(id, 'PHONE'),
        id => exact(id, 'PROFILE'),
        id => multi(id, 'STATUS', 2),
        id => exact(id, 'SINGLE_TENANT_SUBCATEGORY'),
        id => exact(id, 'MULTI_TENANT_SUBCATEGORY'),
        id => exact(id, 'PRICE_MIN'),
        id => exact(id, 'PRICE_MAX'),
        id => exact(id, 'CAP_RATE_MIN'),
        id => exact(id, 'CAP_RATE_MAX'),
        id => exact(id, 'STRIVE_AGENT'),
        id => match(id, 'NOTES'),
        id => match(id, 'COMPANY_NAME'),
        id => match(id, 'COMPANY_ADDRESS'),
        id => match(id, 'COMPANY_CITY'),
        id => exact(id, 'COMPANY_STATE'),
        id => match(id, 'COMPANY_ZIP'),
    ];

    // NOTE: the order of these properties must match the order in the FIRMS_LIST query (/src/data/queries.sql)
    const firmFilter = [
        id => match(id, 'NAME'),
        id => match(id, 'ADDRESS'),
        id => match(id, 'CITY'),
        id => exact(id, 'STATE'),
        id => match(id, 'ZIP'),
        id => match(id, 'PHONE'),
        id => exact(id, 'PARENT_FIRM'),
        id => match(id, 'WEBSITE'),
    ];

    // NOTE: the order in the TENANT_LIST query (/src/data/queries.sql)
    const tenantFilter = [
        id => match(id, 'NAME'),
    ];

    // NOTE: the order of these properties must match the order in the LENDER_LIST query (/src/data/queries.sql)
    const lenderFilter = [
        id => match(id, 'NAME'),
        id => match(id,'CITY'),
        id => match(id,'STATE'),
        id => match(id, 'CONTACT_NAME'),
        id => match(id, 'CONTACT_PHONE'),
        id => match(id, 'CONTACT_EMAIL'),

    ];

    const underwritingMTFilter = [
        id => exact(id, 'PROPERTY_ID'),
    ];

    // NOTE: the order in the STRIVE_FEES query (/src/data/queries.sql)
    const striveFeesFilter = [
        id => date(id, 'START_DATE'),
        id => date(id, 'END_DATE'),
        id => multi(id, 'TRANSACTION_TYPE', 5),
        id => exact(id, 'AGENT_ID'),
    ];

    const propertyOrder = [
        'SOURCE',
        'STATUS',
        'HSC_STATUS',
        'VISIBLE',
        'FEATURED',
        'NAME',
        'ADDRESS',
        'CITY',
        'STATE',
        'ZIP',
        'LATITUDE',
        'LONGITUDE',
        'PHOTOS',
        'HIGHLIGHTS',
        'MEDIA_KIT',
        'TYPE',
        'SQFT',
        'LIST_PRICE',
        'NET_OPERATING_INCOME',
        'VACANCY',
        'CAPITALIZATION_RATE',
        'SOLD_PRICE',
        'DOWN_PAYMENT',
        'EFFECTIVE_DATE',
        'CLOSE_OF_ESCROW',
        'LISTED_DATE',
        'SELLER_FEE_PERCENTAGE',
        'LEASE_TYPE',
        'LEASE_COMMENCEMENT_DATE',
        'LEASE_EXPIRATION_DATE',
        'SELLER_ID',
        'BUYER_ID',
        'YEAR_BUILT',
        'VIDEO_URL',
        'CLOSE_CAP_RATE',
        'CLOSE_NOI',
        'CLOSE_PRICE_PER_SQFT',
        'PRICE_PER_SQFT',
        'LISTING_AGENT_1',
        'LISTING_AGENT_2',
        'LISTING_AGENT_3',
        'LISTING_AGENT_4',
        'LISTING_AGENT_4_FIRM',
        'BUYER_AGENT_1',
        'BUYER_AGENT_2',
        'BUYER_AGENT_3',
        'BUYER_AGENT_4',
        'BUYER_AGENT_4_FIRM',
        'SINGLE_TENANT_SUBCATEGORY',
        'MULTI_TENANT_SUBCATEGORY',
        'TENANT_ID',
        'MARKET',
        'RENT_PER_SQFT',
        'AGENT_1_LAST_NAME',
        'NEGOTIATION_PRICE',
        'NEGOTIATION_CAP_RATE',
        'CATEGORY',
        'SELLERS_LAST_NAME',
        'HSC_PRICE',
        'LOAN_AMOUNT',
        'LTV',
        'INTEREST_RATE',
        'AMORTIZATION',
        'TERM',
        'LENDER_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const buyerBreakdownOrder = [
        'TOTAL_PROPERTIES',
        'COMPANY_STATE',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const defaultOrder = [
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const agentOrder = [
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const sellerOrder = [
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'COMPANY_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const buyerOrder = [
        'STATUS',
        'CATEGORY',
        'TYPE',
        'SINGLE_TENANT_SUBCATEGORY',
        'MULTI_TENANT_SUBCATEGORY',
        'MARKET',
        'PRICE_MIN',
        'PRICE_MAX',
        'CAP_RATE_MIN',
        'CAP_RATE_MAX',
        'FIRST_NAME',
        'LAST_NAME',
        'EMAIL',
        'PHONE',
        'COMPANY_NAME',
        'STRIVE_AGENT_LAST_NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const firmOrder = [
        'NAME',
        'ADDRESS',
        'CITY',
        'STATE',
        'PHONE',
        'WEBSITE',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const tenantOrder = [
        'NAME',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const lenderOrder = [
        'NAME',
        'CITY',
        'STATE',
        'CONTACT_NAME',
        'CONTACT_PHONE',
        'CONTACT_EMAIL',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

    const underwritingMTOrder = [
        'TENANT_ROW_ID',
        'RR_SUITE_CODE',
    ];

    const striveFeesOrder = [
        'CLOSE_OF_ESCROW',
        'ARCIMEDES_ROW_ID', // leave this as last item
    ];

	function match(id, key) {
		if (!query[key]) return;

		param[key] = `%${query[key]}%`;
		where.push(id);
	}

	function exact(id, key) {
		if (!query[key]) return;

		param[key] = query[key];
		where.push(id);
	}

	function num(id, key) {
		if (!query[key]) return;

		const num = fromLocaleString(query[key]);
		if (num !== null) {
			param[key] = num;
			where.push(id);
		}
	}

	function remaingTime(id, key) {
		if (!query[key]) return;

		const num = Number(query[key]);
		if (num === num) {
			const d = new Date();
			const years = Math.floor(num);
			const months = Math.floor(12 * (num - years));
			const days = Math.round(30 * ((12 * (num - years)) - months));
			d.setUTCFullYear(d.getUTCFullYear()+years);
			d.setUTCMonth(d.getUTCMonth()+months);
			d.setUTCDate(d.getUTCDate()+days);
			param[key] = d.toISOString().slice(0,10);
			where.push(id);
		}
	}

	function date(id, key) {
		if (!query[key]) return;

		const date = dateUStoISO(query[key]);
		if (date !== false) {
			param[key] = date;
			where.push(id);
		}
	}

	function multi(id, key, count = 5) {
		if (query[key]) {
			var items = query[key].split(',');
			for (var i = 0; i < count; i++) {
				param[key+`_${i+1}`] = items[i] || 'NOMATCH'; // garbage value that will fail match
			}
			where.push(id);
		}
	}

    let id = 1;
    let filter = [];
    let orderCols = [];
    switch (page) {
        case 'properties':
            orderCols = propertyOrder;
            filter = propertyFilter;
            break;
        case 'buyer-breakdown':
            orderCols = buyerBreakdownOrder;
            filter = buyerBreakdownFilter;
            break;
        case 'transaction-breakdown':
            orderCols = defaultOrder;
            filter = transactionBreakdownFilter;
            break;
        case 'market-transaction-breakdown':
            orderCols = defaultOrder;
            filter = marketTransactionBreakdownFilter;
            break;
        case 'sellers':
            orderCols = sellerOrder;
            filter = sellerFilter;
            break;
        case 'buyers':
            orderCols = buyerOrder;
            filter = buyerFilter;
            break;
        case 'agents':
            orderCols = agentOrder;
            filter = agentFilter;
            break;
        case 'firms':
            orderCols = firmOrder;
            filter = firmFilter;
            break;
        case 'tenants':
            orderCols = tenantOrder;
            filter = tenantFilter;
            break;
        case 'lenders':
            orderCols = lenderOrder;
            filter = lenderFilter;
            break;

        case 'statistics':
            orderCols = defaultOrder;
            filter = [];
            break;
        case 'underwritingMT':
            orderCols = underwritingMTOrder;
            filter = underwritingMTFilter;
            break;
        case 'striveFees':
            orderCols = striveFeesOrder;
            filter = striveFeesFilter;
    }

    filter.forEach((rule) => {
        rule(`CW${id++}`)
    });

    if (['properties', 'buyer-breakdown'].includes(page)) {
        const tenants = (query.TENANT_ID || '').split(',');
        for (let i = 0; i < 15; i++) {
            if (tenants[i]) {
                param[`TENANT${i + 1}`] = tenants[i];
                param[`TENANT${i + 1}_FIRST`] = `${tenants[i]},%`;
                param[`TENANT${i + 1}_LAST`] = `%,${tenants[i]}`;
                param[`TENANT${i + 1}_MID`] = `%,${tenants[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }
    }

    if (page === 'statistics') {
        if (query.PROPERTY_ID) {
            param.PROPERTY_ID = query.PROPERTY_ID;
            param.PROPERTY_ID_FIRST = `${query.PROPERTY_ID},%`;
            param.PROPERTY_ID_LAST = `%,${query.PROPERTY_ID}`;
            param.PROPERTY_ID_MID = `%,${query.PROPERTY_ID},%`;
            where.push('CW' + id);
        }
        id++;
    }

    if (page === 'buyers') {
        const categories = (query.CATEGORY || '').split(',');
        for (let i = 0; i < 4; i++) {
            if (categories[i]) {
                param[`CATEGORY_${i + 1}`] = categories[i];
                param[`CATEGORY_${i + 1}_FIRST`] = `${categories[i]},%`;
                param[`CATEGORY_${i + 1}_LAST`] = `%,${categories[i]}`;
                param[`CATEGORY_${i + 1}_MID`] = `%,${categories[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }

        const types = (query.TYPE || '').split(',');
        for (let i = 0; i < 2; i++) {
            if (types[i]) {
                param[`TYPE_${i + 1}`] = types[i];
                param[`TYPE_${i + 1}_FIRST`] = `${types[i]},%`;
                param[`TYPE_${i + 1}_LAST`] = `%,${types[i]}`;
                param[`TYPE_${i + 1}_MID`] = `%,${types[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }

        const markets = (query.MARKET || '').split(',');
        for (let i = 0; i < 2; i++) {
            if (markets[i]) {
                param[`MARKET_${i + 1}`] = markets[i];
                param[`MARKET_${i + 1}_FIRST`] = `${markets[i]},%`;
                param[`MARKET_${i + 1}_LAST`] = `%,${markets[i]}`;
                param[`MARKET_${i + 1}_MID`] = `%,${markets[i]},%`;
                where.push('CW' + id);
            }
            id++;
        }
    }

	if (query.order) {
		const orders = Array.isArray(query.order) ? query.order : [query.order];

		orders.forEach(x => {
			const [code, direction] = x.split('.');

            orderCols.some((column, i)=> {
				if (column === code) {
					order.push('CO'+(i*2+(direction === 'asc' ? 1 : 2)));
					return true;
				}
			});
		});
	}

	if (page !== 'underwritingMT') {
        if (['properties', 'buyer-breakdown'].includes(page)) {
            order.push('CO' + (orderCols.length * 2));          // ARCIMEDES_ROW_ID descending
        } else {
            order.push('CO' + (orderCols.length * 2 - 1));      // ARCIMEDES_ROW_ID ascending
        }
    }

	return {
		param,
		filter: {
			where
		},
		order,
	};
};